import { render, staticRenderFns } from "./createclinic.vue?vue&type=template&id=faefefb4&"
import script from "./createclinic.vue?vue&type=script&lang=js&"
export * from "./createclinic.vue?vue&type=script&lang=js&"
import style0 from "./createclinic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports